import { useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setCookieConsentModalState, storeCookieConsent } from '../../user/consents/consent-actions';
import { PrimaryButton } from '@sb1/ffe-buttons-react';
import { trackEvent } from '../../support-and-tracking/analytics-actions';
import styles from './modal-cookie-consent.module.less';
import { getCookieConsent } from '../../user/consents/consent-reducer';
import Modal from '../modal/Modal';
import AdministerCookieContent from './AdministerCookiesContent';

const TRACKING_CATEGORY = 'cookie-consent';
const TRACKING_NAME = 'administration';

const AdministerCookieConsentModal = () => {
    const dispatch = useDispatch();
    const cookieConsent = useSelector((state) => getCookieConsent(state), shallowEqual);
    const manualCookieConsentModalOpen = useSelector((state) => state.consent?.manualCookieConsentModalOpen);
    const defaultStatisticsCookieState = cookieConsent
        ? cookieConsent.statistics === undefined || cookieConsent.statistics
        : false;
    const defaultRetargetingCookieState = cookieConsent
        ? cookieConsent.retargeting === undefined || cookieConsent.retargeting
        : false;

    const [statisticsCookiesConsent, setStatisticsCookiesConsent] = useState(defaultStatisticsCookieState);
    const [retargetingCookiesConsent, setRetargetingCookiesConsent] = useState(defaultRetargetingCookieState);
    const [statisticsInfo, setStatisticsInfo] = useState(false);
    const [retargetingInfo, setRetargetingInfo] = useState(false);

    useEffect(() => {
        setStatisticsCookiesConsent(defaultStatisticsCookieState);
    }, [defaultStatisticsCookieState]);

    useEffect(() => {
        setRetargetingCookiesConsent(defaultRetargetingCookieState);
    }, [defaultRetargetingCookieState]);

    const closeModal = () => {
        if (manualCookieConsentModalOpen && hasMadeChanges()) {
            window.location.reload();
        }
        dispatch(setCookieConsentModalState({ open: false }));
        trackEvent(TRACKING_CATEGORY, TRACKING_NAME, { action: 'close' });
    };

    const hasMadeChanges = () =>
        statisticsCookiesConsent !== defaultStatisticsCookieState ||
        retargetingCookiesConsent !== defaultRetargetingCookieState;

    const consentToAll = () => {
        dispatch(
            storeCookieConsent({
                cookies: {
                    ...cookieConsent,
                    statistics: true,
                    retargeting: true,
                },
            })
        );
        trackEvent(TRACKING_CATEGORY, TRACKING_NAME, { action: 'consent-all' });
        closeModal(true);
    };

    const consentToSelected = () => {
        dispatch(
            storeCookieConsent({
                cookies: {
                    ...cookieConsent,
                    statistics: statisticsCookiesConsent,
                    retargeting: retargetingCookiesConsent,
                },
            })
        );
        trackEvent(TRACKING_CATEGORY, TRACKING_NAME, {
            action: 'consent-selected',
            statistics: statisticsCookiesConsent,
            retargeting: retargetingCookiesConsent,
        });
        closeModal();
    };

    return (
        <Modal
            isOpen={manualCookieConsentModalOpen}
            className={'ffe-modal'}
            containerClassName={['ffe-modal__body', styles.modalContainer].join(' ')}
            onRequestClose={() => {
                closeModal();
            }}
        >
            <div className={[styles.contentContainer, 'ffe-modal__block'].join(' ')}>
                <AdministerCookieContent
                    setStatisticsCookiesConsent={setStatisticsCookiesConsent}
                    statisticsCookiesConsent={statisticsCookiesConsent}
                    setRetargetingCookiesConsent={setRetargetingCookiesConsent}
                    retargetingCookiesConsent={retargetingCookiesConsent}
                    statisticsInfo={statisticsInfo}
                    setStatisticsInfo={setStatisticsInfo}
                    retargetingInfo={retargetingInfo}
                    setRetargetingInfo={setRetargetingInfo}
                />
                <div className={styles.buttonsContainer}>
                    <PrimaryButton size="lg" onClick={consentToAll}>
                        Godta alle
                    </PrimaryButton>
                    <PrimaryButton size="lg" onClick={consentToSelected}>
                        Godta valgte
                    </PrimaryButton>
                </div>
            </div>
        </Modal>
    );
};

export default AdministerCookieConsentModal;
